export default __webpack_public_path__ + "static/media/stalkerig_logo.62c07187.png";